import { httpCreate } from './http';

const http = httpCreate('/srv/activity-comment-notice');

export const activityCommentNotice = {
	saveContent(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	changeSwitch(activityId, status) {
		return http.post(`/${activityId}/switch/${status}`);
	},
	saveLocation(activityId, data) {
		return http.post(`/${activityId}/location/${data}`);
	},
};
